export const pushToDataLayer = (eventName, eventParams = {}) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: eventName,
    ...eventParams,
  });
};

export const trackCarouselChange = (category, tab, slide) => {
  pushToDataLayer('carouselChange', {
    eventCategory: category,
    eventAction: tab,
    slide: slide,
  });
};

export const genericEventChange = (event, category, action, label, brandName) => {
  pushToDataLayer(event, {
    eventCategory: category,
    eventAction: action,
    eventLabel: label,
    brandName: brandName,
  });
};
export function pushToDataLayerEvents(data, brandName) {
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push(data);
  }
}
